"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/jsx-no-target-blank */
var react_1 = __importStar(require("react"));
exports.withDisplayName = function (displayName) { return function (Comp) {
    Comp.displayName = displayName;
    return Comp;
}; };
function useOnChange(val, pred, runInitially, equalityFn) {
    if (runInitially === void 0) { runInitially = true; }
    if (equalityFn === void 0) { equalityFn = function (x1, x2) { return x1 === x2; }; }
    var lastVal = react_1.useRef(runInitially ? null : val);
    if (!lastVal.current || !equalityFn(lastVal.current, val)) {
        lastVal.current = val;
        pred(val);
    }
}
exports.useOnChange = useOnChange;
/**
 * A React hook that runs the provided callback exactly once per the lifecycle of the component it is called in.  It is
 * called after the first mount of the component.
 */
exports.useOnce = function (cb) {
    var wasRun = react_1.useRef(false);
    react_1.useEffect(function () {
        if (!wasRun.current) {
            cb();
            wasRun.current = true;
        }
    });
};
exports.useUniqueId = function () {
    var value = react_1.useRef('');
    react_1.useEffect(function () {
        value.current = btoa(Math.random().toString()).replace(/=/g, '');
    }, []);
    return value.current;
};
/**
 * Link that opens in a new tab.
 */
exports.ANewTab = function (_a) {
    var to = _a.to, children = _a.children, text = _a.text, _b = _a.noreferrer, noreferrer = _b === void 0 ? false : _b, props = __rest(_a, ["to", "children", "text", "noreferrer"]);
    return (react_1.default.createElement("a", __assign({ href: to, target: "_blank", rel: "noopener" + (noreferrer ? ' noreferrer' : '') }, props), children || text || ''));
};
// Taken from: https://usehooks.com/useWindowSize/
function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    var _a = react_1.useState({
        width: window.innerWidth,
        height: window.innerHeight,
    }), windowSize = _a[0], setWindowSize = _a[1];
    react_1.useEffect(function () {
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        // Add event listener
        window.addEventListener('resize', handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}
exports.useWindowSize = useWindowSize;
//# sourceMappingURL=react.js.map